import {
  Box,
  Container,
  Typography,
} from "@mui/material";

import AccountTypeCarousel from "components/AccountPricing/AccountTypeCarousel";

const PricingPage = () => {
  return (
    <Box
      sx={{
        py: { xs: 10, md: 14 },
        background: "linear-gradient(135deg,#0f172a,#1e293b)",
        minHeight: "100vh",
      }}
    >
      {/* Hero Section */}
      <Box textAlign="center" sx={{ mb: 6 }}>
        <Typography
          variant="h3"
          sx={{
            color: "#fcfaf6",
            fontWeight: 800,
            fontSize: { xs: "2rem", md: "2.5rem" },
            mb: 2,
          }}
        >
          Simple, Ministry-Friendly Pricing
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "#cbd5e1",
            maxWidth: "650px",
            mx: "auto",
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          Choose a plan that fits your ministry’s needs.
        </Typography>
      </Box>

      {/* Account Type Carousel */}
      <AccountTypeCarousel
        includeCallToActionButton={false}
        excludeIds={[1, 2, 3, 4]}  // Optional: remove alpha/beta or internal types
        onSelect={() => {
          window.location.href = "/register/";
        }}
      />
    </Box>
  );
};

export default PricingPage;
